var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".watermark[data-v-3ab11762]{position:fixed;width:100%;height:100%;pointer-events:none;z-index:100000000000000000000;background:url(" + escape(require("../../../assets/img/water.png")) + ");background-size:100% auto;top:0;left:0}", ""]);

// exports
